import React, { useState } from 'react';
import { Field, Modal, Spinner } from '../../components/ui';
import ExportButton from '../../components/ExportButton';
import { fmtDateTime } from '../../utils/helpers';
import { GUEST_TYPES } from './useCards';
import '../../styles/money.css';

// Mobile Cards — the screen card distribution is run from, in the hand of the
// person walking the round:
//   • it opens on THEIR bundle (Given by = me) with Given / Pending / All;
//   • one tap on ✓ marks a card given, stamped with them and the moment;
//   • tapping the row opens who-gave-it and when, both editable;
//   • ☑ turns the list into tick boxes to close off a whole round at once;
//   • + adds a Guest or a Family without leaving the screen.
export default function CardsMobile({ vm }) {
  const {
    canView, canEdit, cards, counts, loading, functions, fnFilter, setFnFilter,
    typeFilter, setTypeFilter, q, setQ, editing, setEditing, cardForm, setCardF, saveCard, saving,
    openCard, print, ownFamily,
    delivererOptions, myName,
    statusFilter, setStatusFilter,
    adderFilter, setAdderFilter, adderOptions, adderAll, adder, adderSummary, addedByMe, myAdded,
    showAllAdders, showMyAdded, shapeFilter, setShapeFilter, shapeCounts,
    quickQ, setQuickQ, quickMatches, quickGive, clearQuick, giversReport,
    markGiven, givenForm, openGiven, closeGiven, setGivenF, givenNow, saveGiven, unGive,
    selected, toggleSelect, selectedCount, bulkGiveNow, bulkStatus, bulkDeliverer, bulkTake,
    guests,
  } = vm;
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [picking, setPicking] = useState(false);
  const [peopleOpen, setPeopleOpen] = useState(false);

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Cards</h1></div>
        <div className="card card-pad empty">You do not have access to the guest list of this event.</div>
      </div>
    );
  }

  // A filter left on behind the closed panel would silently hide cards. The
  // giver dropdown is in plain sight above, so it does not count here.
  const extraFilters = !!(fnFilter || typeFilter || q || shapeFilter);
  // "All members · 313 cards, 0 given" — the headline before anyone is picked.
  const adderAllLabel = `${adderSummary.total} cards`;
  const stopPick = () => { setPicking(false); cards.forEach(c => selected.has(c.key) && toggleSelect(c.key)); };

  return (
    <div className="mn-cd">
      <div className="mobile-toolbar guest-controls-sticky">
        {/* ONE line where there were two: the page has a title in the tab bar
            already, and the three tiles that used to sit here said exactly what
            the Given / Pending / All bar below says - a phone screen cannot
            afford the same three numbers twice. The member's own whole-event
            figure stays in the dropdown ("… · 0/134 given"). */}
        <div className="mn-cd-head">
          {/* WHOSE CARDS TO GIVE — the first question on the screen. Whoever
              invited a household gives it their card. */}
          <select className="mn-cd-who" value={adderFilter} onChange={e => setAdderFilter(e.target.value)} aria-label="Cards to give by">
            <option value="">All members · {adderAllLabel}</option>
            {adderOptions.map(a => (
              <option key={a.value} value={a.value}>
                {a.label} · {a.total ? `${a.given}/${a.total} given` : 'no cards'}
              </option>
            ))}
          </select>
          {canEdit && (
            <button className={'btn light sm' + (picking ? ' on' : '')} onClick={() => (picking ? stopPick() : setPicking(true))}
              title="Pick several cards">☑</button>
          )}
          <button className={'btn light sm' + (extraFilters ? ' on' : '')} onClick={() => setFiltersOpen(v => !v)}
            title={extraFilters ? 'Filters are on' : 'Filters'}>⚙{extraFilters ? '•' : ''}</button>
        </div>

        <div className="mn-seg m mn-cd-seg">
          {[['', 'All'], ['Pending', 'Pending'], ['Delivered', 'Given']].map(([v, label]) => (
            <button key={v} type="button" className={statusFilter === v ? 'on' : ''} onClick={() => setStatusFilter(v)}>
              {label} {v === '' ? counts.cards : v === 'Pending' ? counts.pending : counts.given}
            </button>
          ))}
        </div>

        {/* The list opens on the cards YOU have to give; one tap sees them all. */}
        <div className="mn-cd-scope muted">
          {addedByMe ? <>Cards you invited · <button className="linklike" onClick={showAllAdders}>show everyone</button></>
            : adder ? (adder.noAdder
              ? <>Cards with <strong>no member recorded</strong> · <button className="linklike" onClick={showAllAdders}>show everyone</button></>
              : <>Invited by <strong>{adder.name}</strong> · <button className="linklike" onClick={showAllAdders}>show everyone</button></>)
              : (
                <>
                  Everyone's cards
                  {myAdded ? <> · <button className="linklike" onClick={showMyAdded}>only mine</button></>
                    : ' · you have invited nobody yet'}
                </>
              )}
          {/* Said here too: a filter behind the ⚙ panel must never hide cards silently. */}
          {shapeFilter && <> · {shapeFilter === 'family' ? 'families' : 'single'} only <button className="linklike" onClick={() => setShapeFilter('')}>clear</button></>}
        </div>

        {filtersOpen && (
          <>
            <div className="mn-filter2">
              <select value={fnFilter} onChange={e => setFnFilter(e.target.value)} aria-label="Function">
                <option value="">All functions</option>
                {functions.map(f => <option key={f.FunctionId} value={f.FunctionId}>{f.FunctionName}</option>)}
              </select>
              <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} aria-label="Type">
                <option value="">All types</option>
                {GUEST_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="mn-filter2">
              <select value={shapeFilter} onChange={e => setShapeFilter(e.target.value)} aria-label="Single or family">
                <option value="">Single + family · {shapeCounts.all}</option>
                <option value="single">Single · {shapeCounts.single}</option>
                <option value="family">Families · {shapeCounts.family}</option>
              </select>
            </div>
            <input type="search" className="mn-search-m" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />
            {/* Printing a sheet of names is a desk job - it does not deserve a
                permanent button on the phone's first screenful. */}
            <div className="mn-cd-filter-tools">
              <button className="btn light sm" onClick={print}>🖨 Print names</button>
              <ExportButton report={giversReport} label="⇪ PDF / Excel" className="btn light sm" />
            </div>
          </>
        )}
      </div>

      {/* ── Everyone's progress ──────────────────────────────────────
          Whoever invited a household gives them their card, so this is the
          whole job in one list: who has finished and who has not. Tap a line
          to work through that person's cards. */}
      {!picking && adderOptions.length > 1 && (
        <div className="card card-pad mn-cd-people-m">
          <button type="button" className="mn-cd-people-head" onClick={() => setPeopleOpen(o => !o)}>
            <strong>Everyone's cards</strong>
            <span className="muted">{adderAll.given}/{adderAll.total} given</span>
            <span className="mn-cd-caret">{peopleOpen ? '▾' : '▸'}</span>
          </button>
          {peopleOpen && (
            <div className="mn-cd-people-list">
              {adderOptions.map(a => (
                <button key={a.value} type="button"
                  className={'mn-cd-person' + (String(adderFilter) === String(a.value) ? ' on' : '') + (a.total && !a.pending ? ' is-done' : '')}
                  onClick={() => setAdderFilter(String(adderFilter) === String(a.value) ? '' : String(a.value))}>
                  <span className="mn-cd-person-name">{a.label}</span>
                  <span className="mn-cd-person-n">
                    {a.total ? <>{a.given}/{a.total}{a.pending ? <b> · {a.pending} left</b> : ' · done ✓'}</> : 'no cards'}
                  </span>
                  <span className="mn-cd-bar"><i style={{ width: `${a.total ? Math.round((a.given / a.total) * 100) : 0}%` }} /></span>
                </button>
              ))}
              {/* The same list as a sheet - everyone's, or just the member
                  chosen in "Cards to give by". */}
              <div className="mn-cd-people-share">
                <ExportButton report={giversReport} label="⇪ PDF / Excel" className="btn light sm" />
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── Search a name, give that card ───────────────────────────
          The move the screen exists for: a guest is standing in front of you.
          It looks through the WHOLE event, not the round on screen. */}
      {canEdit && !picking && (
        <div className="mn-cd-quick-m">
          <div className="mn-cd-quick-row">
            <input type="search" value={quickQ} placeholder="🔍 Give a card — type the name"
              onChange={e => setQuickQ(e.target.value)} />
            {!!quickQ && <button className="btn light sm" onClick={clearQuick} aria-label="Clear">×</button>}
          </div>
          {quickQ.trim().length >= 2 && (
            <div className="mn-cd-hits">
              {quickMatches.length === 0 ? <div className="muted mn-cd-hit-none">Nobody of that name has a card.</div>
                : quickMatches.map(c => (
                  <div key={c.key} className="mn-cd-hit">
                    <div className="mn-cd-hit-who">
                      <strong>{c.name}</strong>
                      <span className="muted">
                        {[c.mobile || 'no number', c.extraCards ? `+${c.extraCards} extra` : '',
                          c.addedBy ? `by ${c.addedBy}` : ''].filter(Boolean).join(' · ')}
                      </span>
                    </div>
                    {c.status === 'Delivered'
                      ? <span className="chip ok">✓ given</span>
                      : <button className="mn-cd-give" onClick={() => quickGive(c)}>Give</button>}
                  </div>
                ))}
            </div>
          )}
        </div>
      )}

      {picking && selectedCount > 0 && (
        <div className="mn-cd-bulk">
          <strong>{selectedCount} picked</strong>
          <button className="btn primary sm" onClick={() => { bulkGiveNow(); setPicking(false); }}>✓ Given now</button>
          {myName && (
            <button className="btn light sm" title="These are now in my hand - not given to the guest yet"
              onClick={() => { bulkTake(); setPicking(false); }}>📥 Take</button>
          )}
          <select className="mn-cd-hand" value="" aria-label="Hand these cards to"
            onChange={e => {
              if (!e.target.value) return;
              bulkDeliverer(e.target.value === '__none' ? '' : e.target.value);
              setPicking(false);
            }}>
            <option value="">Hand to…</option>
            {delivererOptions.filter(d => d.name !== '—').map(d => (
              <option key={d.name} value={d.name}>{d.label}</option>
            ))}
            <option value="__none">Nobody</option>
          </select>
          <button className="btn light sm" onClick={() => { bulkStatus('Pending'); setPicking(false); }}>Pending</button>
        </div>
      )}

      {loading ? <div className="card card-pad"><Spinner /></div>
        : cards.length === 0 ? (
          <div className="card card-pad empty">
            {statusFilter === 'Pending' && counts.cards > 0 ? 'Nothing pending — these are all given.'
              : counts.cards === 0 && adder ? (
                <>{adder.name} has invited nobody who needs a card. <button className="linklike" onClick={showAllAdders}>Show everyone</button>.</>
              ) : 'No cards match.'}
          </div>
        ) : (
          <div className="mobile-card-list mn-cd-list">
            {cards.map((c, i) => {
              const given = c.status === 'Delivered';
              return (
                <div key={c.key} className={'card card-pad mobile-record-card mn-cd-row' + (given ? ' is-given' : '') + (selected.has(c.key) ? ' is-picked' : '')}
                  onClick={() => (picking ? toggleSelect(c.key) : canEdit && openGiven(c))}>
                  {picking && <input type="checkbox" className="mn-cd-tick" checked={selected.has(c.key)} onChange={() => toggleSelect(c.key)} onClick={e => e.stopPropagation()} />}
                  <div className="mn-cd-body">
                    <div className="mn-cd-name">
                      <span className="muted mn-cd-no">{i + 1}.</span> {c.name}
                      {c.extraCards > 0 && <span className="chip warn mn-cd-extra">+{c.extraCards}</span>}
                    </div>
                    <div className="mn-cd-meta muted">
                      {c.mobile || 'no number'}{c.city ? ` · ${c.city}` : ''}
                      {c.cardTypes.length > 0 && ` · ${c.cardTypes.map(t => t.CardTypeName).join(' + ')}`}
                      {!adder && c.addedBy ? ` · by ${c.addedBy}` : ''}
                    </div>
                    <div className="mn-cd-by muted">
                      {given
                        ? `✓ ${c.deliveredBy || 'given'} · ${fmtDateTime(c.deliveredDate)}`
                        : c.deliveredBy ? `with ${c.deliveredBy}` : 'not given to anyone yet'}
                    </div>
                  </div>
                  {!picking && (
                    <div className="mn-cd-acts" onClick={e => e.stopPropagation()}>
                      {c.mobile && <a className="icon-btn" href={`tel:${c.mobile}`} title="Call">📞</a>}
                      <button className="icon-btn" title="Name on the card" disabled={!canEdit} onClick={() => openCard(c)}>✎</button>
                      <button className={'mn-cd-give' + (given ? ' on' : '')} disabled={!canEdit}
                        title={given ? 'Given — tap to see / change' : 'Mark given by me, now'}
                        onClick={() => (given ? openGiven(c) : markGiven(c))}>{given ? '✓' : 'Give'}</button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

      {/* ── Add a guest or a family without leaving the round ───────── */}
      {guests?.canAdd && !!guests.invitableFunctions?.length && !picking && (
        <>
          {addOpen && <button type="button" className="fab-backdrop" aria-label="Close" onClick={() => setAddOpen(false)} />}
          <div className="fab-wrap">
            {addOpen && (
              <div className="fab-menu">
                <button type="button" className="btn light" onClick={() => { setAddOpen(false); guests.openAdd('individual'); }}>👤 Guest</button>
                <button type="button" className="btn light" onClick={() => { setAddOpen(false); guests.openAdd('family'); }}>👪 Family</button>
              </div>
            )}
            <button type="button" className={'fab' + (addOpen ? ' open' : '')} aria-label="Add guests"
              onClick={() => setAddOpen(o => !o)}>{addOpen ? '×' : '+'}</button>
          </div>
        </>
      )}

      {/* ── Given by / when ────────────────────────────────────────── */}
      {givenForm && (
        <Modal
          fullScreen
          title={`Card · ${givenForm.card.name}`}
          onClose={closeGiven}
          footer={<>
            <button className="btn light" style={{ padding: 12 }} onClick={closeGiven}>Cancel</button>
            <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={saveGiven}>
              {saving ? 'Saving…' : givenForm.card.status === 'Delivered' ? 'Save' : '✓ Given'}
            </button>
          </>}
        >
          <div className="mn-cd-guest">
            <strong>{givenForm.card.name}</strong>
            <div className="muted">
              {givenForm.card.mobile || 'no number'}{givenForm.card.city ? ` · ${givenForm.card.city}` : ''}
              {givenForm.card.extraCards > 0 ? ` · +${givenForm.card.extraCards} extra cards` : ''}
            </div>
            {givenForm.card.mobile && <a className="btn light sm" href={`tel:${givenForm.card.mobile}`}>📞 Call</a>}
          </div>

          <label className="field">Given by
            <input list="card-deliverers-m" value={givenForm.by ?? ''} placeholder="who handed it over"
              onChange={e => setGivenF('by', e.target.value)} />
          </label>
          <datalist id="card-deliverers-m">
            {delivererOptions.filter(d => d.name !== '—').map(d => <option key={d.name} value={d.name} />)}
          </datalist>

          <Field label="When" type="datetime-local" value={givenForm.when} onChange={(v) => setGivenF('when', v)} />
          <button className="btn light sm" onClick={givenNow}>Now</button>

          {givenForm.card.status === 'Delivered' && (
            <div style={{ marginTop: 14 }}>
              <button className="btn light" style={{ width: '100%' }} disabled={saving} onClick={unGive}>Not given yet</button>
            </div>
          )}
        </Modal>
      )}

      {/* ── The name printed on the card ───────────────────────────── */}
      {editing && (
        <Modal
          fullScreen
          title={`Name on the card · ${editing.name}`}
          onClose={() => setEditing(null)}
          footer={<>
            <button className="btn light" style={{ padding: 12 }} onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={saveCard}>
              {saving ? 'Saving…' : 'Save'}
            </button>
          </>}
        >
          <div className="mn-seg-wrap">Card for
            <div className="mn-seg m">
              {GUEST_TYPES.map(t => (
                <button key={t} type="button" className={cardForm.GuestType === t ? 'on' : ''}
                  onClick={() => setCardF('GuestType', t)}>{t}</button>
              ))}
            </div>
          </div>
          {cardForm.GuestType === 'Business' && (
            <Field label="Company name" value={cardForm.CompanyName} onChange={(v) => setCardF('CompanyName', v)} />
          )}
          <Field label="Name on the card" value={cardForm.CardName} onChange={(v) => setCardF('CardName', v)}
            placeholder="Leave blank to use the guest's name" />
          <div className="muted" style={{ fontSize: 12 }}>
            One card per household — this applies to every member of the family
            ({editing.members.length} {editing.members.length === 1 ? 'person' : 'people'}: {editing.members.map(m => m.GuestName).filter(Boolean).join(', ')}).
          </div>
        </Modal>
      )}

      {ownFamily > 0 && !loading && (
        <div className="muted mn-cd-foot">{ownFamily} people are marked “no card” (own family / count-only groups).</div>
      )}
    </div>
  );
}
